/*
 * Copyright (c) Nexign, JSC, 2020.
 */

/**
 * The constants for WizardReport component
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.2.0
 */


export enum EWizardReportParam {
    EMAIL = 'reportEmail',
    PHONE = 'reportPhone',
    EMAIL_DEST = 'reportDestEmail',
    SUBSCRIBERS_PHONE = 'reportSubscribersPhone',
    SUBS_NOTIFICATION_NEEDED = 'subsNotificationNeeded',
    ZIP = 'reportNeedCompression',
    ZIP_PASSWORD = 'reportCompressionPassword',
}

export enum EWizardReportApiValidationFields {
    EMAIL = 'notify.email',
    PHONE = 'notify.phone',
    EMAIL_DEST = 'data.destEmail',
    SUBSCRIBERS_PHONE = 'notify.subscribersPhone',
    SUBS_NOTIFICATION_NEEDED = 'notify.subsNotificationNeeded',
    ZIP = 'data.needCompression',
    ZIP_PASSWORD = 'data.compressionPassword',
}

export const mapWizardReportApiToParams: { [key in EWizardReportApiValidationFields]: EWizardReportParam } = {
    [EWizardReportApiValidationFields.EMAIL]: EWizardReportParam.EMAIL,
    [EWizardReportApiValidationFields.PHONE]: EWizardReportParam.PHONE,
    [EWizardReportApiValidationFields.EMAIL_DEST]: EWizardReportParam.EMAIL_DEST,
    [EWizardReportApiValidationFields.SUBSCRIBERS_PHONE]: EWizardReportParam.SUBSCRIBERS_PHONE,
    [EWizardReportApiValidationFields.SUBS_NOTIFICATION_NEEDED]: EWizardReportParam.SUBS_NOTIFICATION_NEEDED,
    [EWizardReportApiValidationFields.ZIP]: EWizardReportParam.ZIP,
    [EWizardReportApiValidationFields.ZIP_PASSWORD]: EWizardReportParam.ZIP_PASSWORD,
};
